"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2174],{

/***/ 51906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Advantage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./app/services/index.js + 2 modules
var services = __webpack_require__(64380);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./app/theme/index.js + 2 modules
var theme = __webpack_require__(57895);
// EXTERNAL MODULE: ./app/theme/measurements.js
var measurements = __webpack_require__(53597);
;// CONCATENATED MODULE: ./components/Advantage/styles.js


var advantage = new String(".container-advantage.jsx-c7f57af8e27cf80d{max-width:".concat(measurements/* default.containerSize */.Z.containerSize, ";\nwidth:100%;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\nflex-wrap:nowrap;\nbackground-color:").concat(theme/* colors.white */.O9.white, ";\nbox-shadow:0 8px 20px 0 rgba(197, 207, 222, 0.5);\nborder-radius:").concat(measurements/* default.borderRadius */.Z.borderRadius, ";\nposition:relative;\ntop:-41px;\nmargin:0 auto;\n-webkit-flex-direction:row;\n-ms-flex-direction:row;\nflex-direction:row;\noverflow:auto}\n.advantage.jsx-c7f57af8e27cf80d{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\nborder-top:solid 1px ").concat(theme/* colors.border */.O9.border, ";\nborder-bottom:solid 1px ").concat(theme/* colors.border */.O9.border, ";\nmax-width:17rem}\n.advantage.jsx-c7f57af8e27cf80d:last-child{border-right:solid 1px ").concat(theme/* colors.border */.O9.border, ";\nborder-top-right-radius:").concat(measurements/* default.borderRadius */.Z.borderRadius, ";\nborder-bottom-right-radius:").concat(measurements/* default.borderRadius */.Z.borderRadius, "}\n.advantage.jsx-c7f57af8e27cf80d:first-child{border-left:solid 1px ").concat(theme/* colors.border */.O9.border, ";\nborder-top-left-radius:").concat(measurements/* default.borderRadius */.Z.borderRadius, ";\nborder-bottom-left-radius:").concat(measurements/* default.borderRadius */.Z.borderRadius, "}\n.advantage.jsx-c7f57af8e27cf80d:hover, .advantage.active.jsx-c7f57af8e27cf80d{background-color:").concat(theme/* colors.text */.O9.text, ";\nborder-color:").concat(theme/* colors.text */.O9.text, ";\n-webkit-transition:400ms background-color, 400ms border;\ntransition:400ms background-color, 400ms border}\n.advantage.jsx-c7f57af8e27cf80d:first-child:hover, .advantage.jsx-c7f57af8e27cf80d:first-child.active{border-right:none}\n.advantage.jsx-c7f57af8e27cf80d:last-child:hover, .advantage.jsx-c7f57af8e27cf80d:last-child.active{border-left:none}\n.advantage.jsx-c7f57af8e27cf80d:hover .advantage-link.jsx-c7f57af8e27cf80d, .advantage.active.jsx-c7f57af8e27cf80d .advantage-link.jsx-c7f57af8e27cf80d{color:").concat(theme/* colors.white */.O9.white, "}\n.advantage.jsx-c7f57af8e27cf80d .advantage-link.jsx-c7f57af8e27cf80d{color:").concat(theme/* colors.text */.O9.text, ";\ntext-align:center;\nfont:").concat(theme/* fonts.semiBold */.Rq.semiBold, ";\npadding:10px 1.1rem 20px}\n.advantage-description.jsx-c7f57af8e27cf80d{display:block}\n@media screen and (max-width:992px) {.container-advantage.jsx-c7f57af8e27cf80d{-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\npadding:2rem}\n.container-advantage.jsx-c7f57af8e27cf80d .advantage.jsx-c7f57af8e27cf80d{width:100%;\nmin-width:100%;\n-webkit-justify-content:center;\njustify-content:center;\nborder:none;\nborder-top:solid 1px ").concat(theme/* colors.border */.O9.border, "}\n.advantage.jsx-c7f57af8e27cf80d:hover, .advantage.active.jsx-c7f57af8e27cf80d{border-radius:0}}"));
advantage.__hash = "c7f57af8e27cf80d";

;// CONCATENATED MODULE: ./components/Advantage/index.js







function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var Advantage = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(Advantage, Component1);
    var _super = _createSuper(Advantage);
    function Advantage(props) {
        _classCallCheck(this, Advantage);
        var _this;
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "activeItem", function(item) {
            return item.url === _this.props.pathname ? 'active' : '';
        });
        _defineProperty(_assertThisInitialized(_this), "getIcon", function(item) {
            var isActive = _this.activeItem(item) === 'active';
            var _state = _this.state, hover = _state.hover, currentIcon = _state.currentIcon;
            if (isActive) {
                return item.icon.replace('.svg', '-white.svg');
            }
            if (hover && item.icon === currentIcon) {
                return item.icon.replace('.svg', '-white.svg');
            }
            return item.icon;
        });
        _this.state = {
            hover: false,
            currentIcon: null
        };
        return _this;
    }
    _createClass(Advantage, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                var _this = this;
                var advantageList = [
                    {
                        title: 'Capta m\xe1s propiedades',
                        icon: '/advantage/icono-captar.svg',
                        url: '/acquire-more-properties',
                        asUrl: '/capta-propiedades'
                    },
                    {
                        title: 'Genera m\xe1s contactos',
                        icon: '/advantage/icono-promover.svg',
                        url: '/better-serve-your-clients',
                        asUrl: '/ayuda-tus-clientes'
                    },
                    {
                        title: 'Desarrolla relaciones s\xf3lidas con tus clientes',
                        icon: '/advantage/icono-crm.svg',
                        url: '/transaction-management',
                        asUrl: '/gestion-transaccion'
                    },
                    {
                        title: 'Convi\xe9rtete en un experto inmobiliario en tu zona',
                        icon: '/advantage/icono-capacitacion.svg',
                        url: '/personal-development',
                        asUrl: '/desarrollo-personal'
                    },
                    {
                        title: 'Soporte por nuestros expertos legales y fiscales',
                        icon: '/advantage/icono-soporte.svg',
                        url: '/administrative-support',
                        asUrl: '/soporte-administrativo'
                    },
                    {
                        title: 'Comisiones justas',
                        icon: '/advantage/icono-100-comision.svg',
                        url: '/promote-your-properties',
                        asUrl: '/promueve-propiedades'
                    }
                ];
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: /*#__PURE__*/ "jsx-".concat(advantage.__hash) + " " + "container-advantage",
                    children: [
                        advantageList.map(function(item, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                onMouseEnter: function() {
                                    return _this.setState({
                                        hover: true,
                                        currentIcon: item.icon
                                    });
                                },
                                onMouseLeave: function() {
                                    return _this.setState({
                                        hover: false,
                                        currentIcon: null
                                    });
                                },
                                className: "jsx-".concat(advantage.__hash) + " " + (classnames_default()('advantage', _this.activeItem(item)) || ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: item.url,
                                    as: item.asUrl,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "jsx-".concat(advantage.__hash) + " " + "advantage-link",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: (0,services/* image */.BH)(_this.getIcon(item)),
                                                className: "jsx-".concat(advantage.__hash)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "jsx-".concat(advantage.__hash) + " " + "advantage-description",
                                                children: item.title
                                            })
                                        ]
                                    })
                                })
                            }, index);
                        }),
                        (0,jsx_runtime.jsx)(style["default"], {
                            id: advantage.__hash,
                            children: advantage
                        })
                    ]
                }));
            }
        }
    ]);
    return Advantage;
}(react.Component);
/* harmony default export */ var components_Advantage = (Advantage);


/***/ }),

/***/ 65938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ heroConfiguration; }
/* harmony export */ });
/* harmony import */ var globalConfigApp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19169);

var params = {
    simpleSrp: {
        title: "Vende, Compra o Renta en confianza con ".concat(globalConfigApp__WEBPACK_IMPORTED_MODULE_0__/* .companyConfig.name */ .p2.name),
        subTitle: 'Estamos aqu\xed para guiarlo y responder a sus preguntas con datos precisos y los mejores expertos locales',
        image: 'landing/hero/srp/photo-68360119.jpg',
        buttons: []
    },
    home: {
        title: "Vende, Compra o Renta en confianza con ".concat(globalConfigApp__WEBPACK_IMPORTED_MODULE_0__/* .companyConfig.name */ .p2.name),
        buttons: [],
        customStyles: {},
        heroTypeClass: 'solid-hero'
    },
    srp: {
        title: "Vende, Compra o Renta en confianza con ".concat(globalConfigApp__WEBPACK_IMPORTED_MODULE_0__/* .companyConfig.name */ .p2.name),
        subTitle: 'Estamos aqu\xed para guiarlo y responder a sus preguntas con datos precisos y los mejores expertos locales',
        image: 'landing/hero/srp/DSC00055.jpg',
        buttons: []
    },
    about: {
        title: 'Nos encargamos de todo tu trabajo administrativo para que te enfoques en tus actividades m\xe1s productivas',
        subTitle: '',
        image: 'landing/hero/about/hi-i.jpg',
        buttons: [
            // {
            //   title: 'Aprende más',
            //   href: '/about',
            //   color: 'primary',
            //   outline: true,
            //   variation: true
            // },
            {
                title: 'Me interesa',
                href: '/signup',
                asUrl: '/registrarse',
                color: 'primary'
            }
        ]
    },
    administrative: {
        title: 'Nos encargamos de todo tu trabajo administrativo para que te enfoques en tus actividades m\xe1s productivas',
        subTitle: '',
        image: 'landing/hero/administrative/hi-f.jpg',
        buttons: [
            // {
            //   title: 'Aprende más',
            //   href: '/about',
            //   href: '/about',
            //   color: 'primary',
            //   outline: true,
            //   variation: true
            // },
            {
                title: 'Me interesa',
                href: '/signup',
                asUrl: '/registrarse',
                color: 'primary'
            }
        ]
    },
    development: {
        title: 'Oportunidades de crecimiento personal y profesional',
        subTitle: '',
        image: 'landing/hero/development/hi-e.jpg',
        buttons: [
            // {
            //   title: 'Aprende más',
            //   href: '/about',
            //   color: 'primary',
            //   outline: true,
            //   variation: true
            // },
            {
                title: 'Me interesa',
                href: '/signup',
                asUrl: '/registrarse',
                color: 'primary'
            }
        ]
    },
    homepage: {
        title: "Transforma tu vida y la de tus clientes con ".concat(globalConfigApp__WEBPACK_IMPORTED_MODULE_0__/* .companyConfig.name */ .p2.name, ", la nueva alianza inmobiliaria de M\xe9xico "),
        subTitle: "Gana el 75% de comisiones con ".concat(globalConfigApp__WEBPACK_IMPORTED_MODULE_0__/* .companyConfig.name */ .p2.name),
        image: 'landing/hero/homepage/hi-a.jpg',
        buttons: [
            // {
            //   title: 'Aprende más',
            //   icon: '',
            //   href: '/about',
            //   color: 'primary',
            //   outline: true,
            //   variation: true
            // },
            {
                title: 'Me interesa',
                href: '/signup',
                asUrl: '/registrarse',
                color: 'primary'
            }
        ]
    },
    transactionManagement: {
        title: 'Gestiona toda tu transaccion a traves de nuestro CRM interno',
        subTitle: "Gana el 75% de comisiones con ".concat(globalConfigApp__WEBPACK_IMPORTED_MODULE_0__/* .companyConfig.name */ .p2.name),
        image: 'landing/hero/management/hi-g.jpg',
        buttons: [
            {
                title: 'Me interesa',
                href: '/signup',
                asUrl: '/registrarse',
                color: 'primary'
            }
        ]
    },
    promoteYourProperties: {
        title: "Gana el 75% de comisiones con ".concat(globalConfigApp__WEBPACK_IMPORTED_MODULE_0__/* .companyConfig.name */ .p2.name),
        subTitle: 'Todos los servicios que necesitas a un precio fijo.',
        image: '/landing/hero/promote/hi-c.jpg',
        buttons: [
            {
                title: 'Comienza',
                href: '/signup',
                asUrl: 'registrarse',
                icon: '',
                color: 'primary',
                outline: true,
                variation: true
            },
            {
                title: 'Me interesa',
                href: '/signup',
                asUrl: '/registrarse',
                color: 'primary'
            }
        ]
    },
    'acquire-more-properties': {
        title: 'Adquiere mas propiedades en exclusivas con nuestro servicio exclusivo de captaci\xf3n de propiedades',
        subTitle: "Gana el 75% de comisiones con ".concat(globalConfigApp__WEBPACK_IMPORTED_MODULE_0__/* .companyConfig.name */ .p2.name),
        image: '/landing/hero/more-properties/hi-b.jpg',
        buttons: [
            {
                title: 'Comienza',
                href: '/signup',
                asUrl: 'registrarse',
                icon: '',
                color: 'primary',
                outline: true,
                variation: true
            },
            {
                title: 'Me interesa',
                href: '/signup',
                asUrl: '/registrarse',
                color: 'primary'
            }
        ]
    },
    betterServeYourClients: {
        title: 'Vende o Renta m\xe1s rapido con el paquete de multi-difusion m\xe1s potente de M\xe9xico',
        subTitle: '',
        image: 'landing/hero/services/hi-d.jpg',
        buttons: [
            {
                title: 'Comienza',
                href: '/signup',
                asUrl: 'registrarse',
                color: 'primary',
                outline: true,
                variation: true
            },
            {
                title: 'Me interesa',
                href: '/signup',
                asUrl: '/registrarse',
                color: 'primary'
            }
        ]
    },
    prices: {
        title: 'Elige el plan perfecto para ti',
        subTitle: 'Todos los servicios que necesitas a un precio fijo.',
        image: 'landing/hero/prices/hi-h.jpg',
        buttons: []
    },
    help: {
        title: 'Hola, \xbfEn qu\xe9 podemos ayudarte?',
        subTitle: '',
        image: '/hero/faq/hero-help.png',
        buttons: []
    },
    defaultConfig: {
        title: '',
        subTitle: '',
        image: '',
        buttons: []
    }
};
function heroConfiguration(type) {
    return params[type] ? params[type] : params['defaultConfig'];
};


/***/ }),

/***/ 7112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export Hero */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65988);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var controls__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16389);
/* harmony import */ var services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64380);
/* harmony import */ var flexbox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91584);
/* harmony import */ var flexbox__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(flexbox__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _heroConfiguration__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65938);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48586);










function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var Hero = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(Hero, Component1);
    var _super = _createSuper(Hero);
    function Hero() {
        _classCallCheck(this, Hero);
        var _this;
        _this = _super.apply(this, arguments);
        _defineProperty(_assertThisInitialized(_this), "renderButton", function(btn, index) {
            /*#__PURE__*/ return((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(controls__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                color: btn.color,
                outline: btn.outline,
                variation: btn.variation,
                href: btn.href,
                as: btn.asUrl,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        style: btn.icon ? {
                            marginRight: '0.5rem'
                        } : {},
                        /*#__PURE__*/ children: btn.title
                    }),
                    btn.icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(controls__WEBPACK_IMPORTED_MODULE_3__/* .MaterialIcon */ .OL, {
                        icon: btn.icon,
                        className: "large"
                    }) : ''
                ]
            }, "button-".concat(index)));
        });
        return _this;
    }
    _createClass(Hero, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, subTitle = _props.subTitle, imageName = _props.image, children = _props.children, buttons = _props.buttons;
                var style = {
                    backgroundImage: "url(\"".concat((0,services__WEBPACK_IMPORTED_MODULE_4__/* .image */ .BH)(imageName), "\")")
                };
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        width: '100%'
                    },
                    className: "jsx-".concat(_styles__WEBPACK_IMPORTED_MODULE_7__/* .hero.__hash */ .rP.__hash),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            style: style,
                            className: "jsx-".concat(_styles__WEBPACK_IMPORTED_MODULE_7__/* .hero.__hash */ .rP.__hash) + " " + "hero-container",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
                                    className: "jsx-".concat(_styles__WEBPACK_IMPORTED_MODULE_7__/* .hero.__hash */ .rP.__hash) + " " + "text primary",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "jsx-".concat(_styles__WEBPACK_IMPORTED_MODULE_7__/* .hero.__hash */ .rP.__hash) + " " + "text secondary",
                                    children: subTitle
                                }),
                                children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "jsx-".concat(_styles__WEBPACK_IMPORTED_MODULE_7__/* .hero.__hash */ .rP.__hash) + " " + "container-children",
                                    children: children
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "jsx-".concat(_styles__WEBPACK_IMPORTED_MODULE_7__/* .hero.__hash */ .rP.__hash) + " " + "buttons-container",
                                    children: buttons.map(this.renderButton)
                                })
                            ]
                        }),
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__["default"], {
                            id: _styles__WEBPACK_IMPORTED_MODULE_7__/* .hero.__hash */ .rP.__hash,
                            children: _styles__WEBPACK_IMPORTED_MODULE_7__/* .hero */ .rP
                        })
                    ]
                }));
            }
        }
    ]);
    return Hero;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
_defineProperty(Hero, "propTypes", {
    title: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string.isRequired),
    subTitle: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string.isRequired),
    image: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string.isRequired)
});
var HeroWrapper = function(param) {
    var type = param.type, children = param.children;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Hero, _objectSpread({}, (0,_heroConfiguration__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(type), {
        children: children
    }));
};
HeroWrapper.propTypes = {
    type: prop_types__WEBPACK_IMPORTED_MODULE_8___default().oneOf([
        'about',
        'homepage',
        'promoteYourProperties',
        'betterServeYourClients',
        'transactionManagement',
        'administrative',
        'help'
    ])
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroWrapper);


/***/ }),

/***/ 48586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "rP": function() { return /* binding */ hero; },
/* harmony export */   "ZB": function() { return /* binding */ srp; },
/* harmony export */   "wc": function() { return /* binding */ item; }
/* harmony export */ });
/* harmony import */ var services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64380);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57895);
/* harmony import */ var theme_fonts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18437);
/* harmony import */ var _app_theme_measurements__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53597);
/* harmony import */ var _controls_DropDown_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42440);





var hero = new String(".hero-container.jsx-c51a8c0bcddae543{height:calc(90vh);\nwidth:100%;\nbackground-repeat:no-repeat;\nbackground-size:cover;\nbackground-position-x:center;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\ntext-align:center}\n.hero-container.esp.jsx-c51a8c0bcddae543{text-aling:center}\n.hero-container.esp.jsx-c51a8c0bcddae543:before{content:' ';\ndisplay:block;\nposition:absolute;\nleft:0;\ntop:0;\nwidth:100%;\nheight:68%;\nz-index:0;\nopacity:0.2;\nbackground:black;\nbackground-size:cover;\nheight:calc(68vh)}\n.hero-container.solid-hero.jsx-c51a8c0bcddae543{padding-top:2.5rem;\nbackground-color:".concat(theme__WEBPACK_IMPORTED_MODULE_1__/* .colors.heroBg */ .O9.heroBg, ";\nmin-height:22rem;\nheight:-webkit-fit-content;\nheight:-moz-fit-content;\nheight:fit-content;\nbox-shadow:inset 0rem 10rem 8rem -7rem ").concat(theme__WEBPACK_IMPORTED_MODULE_1__/* .colors.alpha */ .O9.alpha(theme__WEBPACK_IMPORTED_MODULE_1__/* .colors.black */ .O9.black, 0.5), "}\n.text.jsx-c51a8c0bcddae543{color:").concat(theme__WEBPACK_IMPORTED_MODULE_1__/* .colors.white */ .O9.white, ";\nline-height:3rem;\nfont:").concat(theme__WEBPACK_IMPORTED_MODULE_1__/* .fonts.bold */ .Rq.bold, ";\nmax-width:1000px}\n.text.primary.jsx-c51a8c0bcddae543{font:").concat(theme__WEBPACK_IMPORTED_MODULE_1__/* .fonts.semiBold */ .Rq.semiBold, ";\nfont-size:").concat(theme_fonts__WEBPACK_IMPORTED_MODULE_2__/* .fontSizes.h1 */ .CH.h1, "}\n.text.secondary.jsx-c51a8c0bcddae543{margin:0 0 1rem;\nfont-size:").concat(theme_fonts__WEBPACK_IMPORTED_MODULE_2__/* .fontSizes.body */ .CH.body, ";\nfont-weight:400}\n.container-children.jsx-c51a8c0bcddae543{width:100%}\n.buttons.jsx-c51a8c0bcddae543{margin-top:3rem;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:row;\n-ms-flex-direction:row;\nflex-direction:row}\n.buttons.jsx-c51a8c0bcddae543 .button.jsx-c51a8c0bcddae543{margin:0 1rem}\n.buttons-container.jsx-c51a8c0bcddae543{margin-top:3rem;\nwidth:100%;\nmax-width:800px;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-justify-content:center;\njustify-content:center}\n.buttons-container.jsx-c51a8c0bcddae543>*{margin-right:2rem}\n.buttons-container.jsx-c51a8c0bcddae543>*:last-child{margin-right:0}\n.buttons-container.jsx-c51a8c0bcddae543 button{width:10rem}\n@media screen and (max-width:992px) {.text.primary.jsx-c51a8c0bcddae543{text-align:center;\nfont-size:1.5rem;\npadding:1rem}\n.text.secondary.jsx-c51a8c0bcddae543{padding:0.5rem 2.5rem;\nfont-size:1rem;\ntext-align:center}\n.buttons-container.jsx-c51a8c0bcddae543{-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column}\n.buttons-container.jsx-c51a8c0bcddae543>*{margin-right:0;\nmargin-bottom:1rem}\n.buttons-padding.jsx-c51a8c0bcddae543{padding:0.625rem}\n.text.primary.jsx-c51a8c0bcddae543{padding:0}\n.buttons-container.jsx-c51a8c0bcddae543{margin:0}\n.hero-container.solid-hero.jsx-c51a8c0bcddae543{padding:5rem 0 3rem}}\n.hero-container.jsx-c51a8c0bcddae543{height:calc(68vh)}\n.hero-container.nexsite1-hero-srp.jsx-c51a8c0bcddae543{height:auto;\nmargin-bottom:3.75rem}\n.hero-container.nexsite1-hero-srp.jsx-c51a8c0bcddae543 header.jsx-c51a8c0bcddae543{margin-bottom:1.5625rem;\ntext-shadow:0 0 0.3125rem rgba(0, 0, 0, 0.2)}\n.hero-container.nexsite1-hero-srp.jsx-c51a8c0bcddae543 .text.secondary.jsx-c51a8c0bcddae543{margin-bottom:2.1875rem;\ntext-shadow:0 0 0.3125rem rgba(0, 0, 0, 0.2)}"));
hero.__hash = "c51a8c0bcddae543";
var srp = new String(".actions.jsx-34abc0f48f326a9e{background-color:".concat(theme__WEBPACK_IMPORTED_MODULE_1__/* .colors.white */ .O9.white, ";\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:space-evenly;\njustify-content:space-evenly;\nwidth:100%;\nmax-width:57.5rem;\nposition:relative;\nborder-radius:").concat(_app_theme_measurements__WEBPACK_IMPORTED_MODULE_3__/* ["default"].borderRadius */ .Z.borderRadius, ";\nheight:3.5rem}\n.actions.jsx-34abc0f48f326a9e, .up-bottons-container.jsx-34abc0f48f326a9e{max-width:57.5rem}\n.actions.jsx-34abc0f48f326a9e .select-container{margin-top:0;\nheight:100%}\n.actions.jsx-34abc0f48f326a9e .dropdown-srp{border-right:solid 1px ").concat(theme__WEBPACK_IMPORTED_MODULE_1__/* .colors.border */ .O9.border, "}\n.actions.jsx-34abc0f48f326a9e .select-container .dropdown-srp, .actions.jsx-34abc0f48f326a9e .select-container .suggest-places{height:100%;\nborder:none}\n.actions.jsx-34abc0f48f326a9e .dropdown-srp.open .dropdown-srp{border-right:none}\n.actions.jsx-34abc0f48f326a9e .dropdown-srp{min-width:16%;\nborder-top-right-radius:0;\nborder-top-left-radius:0}\n.actions.jsx-34abc0f48f326a9e .react-selectize.bootstrap3.root-node .react-selectize-control{border:none}\n.actions.jsx-34abc0f48f326a9e .geo-suggest-srp{min-width:68%;\nborder:none}\n.hero-container.jsx-34abc0f48f326a9e .actions.jsx-34abc0f48f326a9e .search-button{position:absolute;\nright:0;\nwidth:11rem;\nheight:3.5rem;\nborder-radius:0 ").concat(_app_theme_measurements__WEBPACK_IMPORTED_MODULE_3__/* ["default"].borderRadius */ .Z.borderRadius, " ").concat(_app_theme_measurements__WEBPACK_IMPORTED_MODULE_3__/* ["default"].borderRadius */ .Z.borderRadius, " 0}\n.hero-container.jsx-34abc0f48f326a9e .actions.jsx-34abc0f48f326a9e .suggest-places{width:24rem;\nmin-width:45%;\nmargin-right:11rem}\n.hidden.jsx-34abc0f48f326a9e{display:none}\n.up-bottons-container.jsx-34abc0f48f326a9e{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:flex-start;\n-webkit-box-align:flex-start;\n-ms-flex-align:flex-start;\nalign-items:flex-start;\nmargin-bottom:0.5rem;\nwidth:100%;\nmargin:0 auto 0.5rem}\n@media screen and (max-width:992px) {.hero-container.jsx-34abc0f48f326a9e .actions.jsx-34abc0f48f326a9e, .up-bottons-container.jsx-34abc0f48f326a9e{max-width:90%;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\nheight:auto}\n.hero-container.jsx-34abc0f48f326a9e .actions.jsx-34abc0f48f326a9e .search-button{position:relative;\nwidth:100%;\nborder-radius:0 0 ").concat(_app_theme_measurements__WEBPACK_IMPORTED_MODULE_3__/* ["default"].borderRadius */ .Z.borderRadius, " ").concat(_app_theme_measurements__WEBPACK_IMPORTED_MODULE_3__/* ["default"].borderRadius */ .Z.borderRadius, ";\npadding:1rem}\n.hero-container.jsx-34abc0f48f326a9e .actions.jsx-34abc0f48f326a9e .dropdown-srp{border-right:none}\n.hero-container.jsx-34abc0f48f326a9e .actions.jsx-34abc0f48f326a9e .suggest-places{width:100%;\nmargin:0}\n.hero-container.jsx-34abc0f48f326a9e .actions.jsx-34abc0f48f326a9e select.dropdown-srp, .hero-container.jsx-34abc0f48f326a9e .actions.jsx-34abc0f48f326a9e select.suggest-places{height:3.5rem}}\n.tt-suggestion.jsx-34abc0f48f326a9e{padding:4px 70px 4px 10px;\noverflow:hidden;\nwhite-space:nowrap;\ntext-overflow:ellipsis;\ntext-align:left;\ncolor:").concat(theme__WEBPACK_IMPORTED_MODULE_1__/* .colors.rent */ .O9.rent, "}\n.tt-suggestion-level.jsx-34abc0f48f326a9e{font-size:12px;\nfloat:right;\ncolor:").concat(theme__WEBPACK_IMPORTED_MODULE_1__/* .colors.dirtGray */ .O9.dirtGray, ";\nposition:absolute;\nright:10px}"));
srp.__hash = "34abc0f48f326a9e";
var item = new String(".item.jsx-9d5a8e9394b79313{color:".concat(_controls_DropDown_styles__WEBPACK_IMPORTED_MODULE_4__/* .dropDownProps.optionTextColor */ .GG.optionTextColor, ";\nfont:").concat(theme__WEBPACK_IMPORTED_MODULE_1__/* .fonts.medium */ .Rq.medium, ";\nline-height:").concat(_controls_DropDown_styles__WEBPACK_IMPORTED_MODULE_4__/* .dropDownProps.minHeight */ .GG.minHeight, ";\nfont-size:").concat(theme_fonts__WEBPACK_IMPORTED_MODULE_2__/* .fontSizes.p */ .CH.p, ";\ndisplay:block;\nbackground:").concat(theme__WEBPACK_IMPORTED_MODULE_1__/* .colors.white */ .O9.white, ";\nmargin:0;\nwhite-space:nowrap;\noverflow:hidden;\ntext-overflow:ellipsis;\nmax-width:300px}"));
item.__hash = "9d5a8e9394b79313";


/***/ })

}]);